module.exports = __webpack_public_path__ + "static/img/3.896c9c07.png";